import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CoreLogService } from "../../../core/services/log.service";
import Utils from "../../../core/shared/utils";
import { ISOTService } from '../../services';

export interface ChoiceDialogConfig {
  /**Language key(s) for the dialog text */
  langkey: string | string[];
  /** Dialog buttons configuration */
  buttons: ChoiceButtonConfig[];
  /** select one or more buttons as highlighted */
  highlighted_button_index?: number | number[];
  /** select one button to use default button style */
  default_button_index?: number;
  /** displays the buttons in a row, else in a column */
  buttons_in_row?: boolean;
  /** Optional icon identifier*/
  icon?: string;
  /** SOT service  */
  sot_service: ISOTService;
}

export interface ChoiceButtonConfig {
  langkey: string;
  icon?: string;
  onClick: (dialog_ref: MatDialogRef<SelectionDialogComponent>) => void;
}

@Component({
  selector: "sot-selectiondialog",
  templateUrl: "./selectionDialog.component.html",
  styleUrls: ["./selectionDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectionDialogComponent implements OnInit, OnDestroy {

  public texts: string[] = [];
  public buttons: ChoiceButtonConfig[] = [];
  public buttons_in_row: boolean = true;
  public dialog_icon?: string;
  public secondery_button_index: number = -1;
  public highlighted_button_indices: number[] = [];

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , public dialogRef: MatDialogRef<SelectionDialogComponent, any>
    , @Inject(MAT_DIALOG_DATA) public data: ChoiceDialogConfig
    , private _coreLogService: CoreLogService) { }

  public ngOnInit(): void {
    console.debug("--- sot-selectiondialog ngOnInit")
    const me = this;
    me.initFromData();
    me.PushChanges();
  }

  public get isModeOne(): boolean {
    return this.data.sot_service.Accessabilty.useModeOne;
  }

  public get isModeTwo(): boolean {
    return this.data.sot_service.Accessabilty.useModeTwo;
  }

  private initFromData(): void {
    this.buttons = this.data.buttons;
    this.setButtonsInRow(this.data.buttons_in_row);
    this.setTextsFromLangKey(this.data.langkey);
    this.setDefaultButtonStyle(this.data);
    this.setHighlightedButton(this.data);
    this.dialog_icon = this.data.icon;
  }

  private setButtonsInRow(setButtonsInRow: boolean) {
    const me = this;
    if (!Utils.IsNull(setButtonsInRow)) {
      me.buttons_in_row = setButtonsInRow;
    }
    // else default direction is column
  }

  private setTextsFromLangKey(langkeys: string | string[]) {
    const me = this;
    me.texts = Array.isArray(langkeys) ? langkeys : [langkeys];
  }

  private setHighlightedButton(data: ChoiceDialogConfig): void {
    const me = this;
    if (data.highlighted_button_index == null) { return; }
    const raw = Array.isArray(data.highlighted_button_index) ? data.highlighted_button_index : [data.highlighted_button_index];
    me.highlighted_button_indices = raw.filter((index) => index >= 0 && index < me.buttons.length);
  }

  private setDefaultButtonStyle(data: ChoiceDialogConfig) {
    const me = this;
    if (data.default_button_index != null &&
      data.default_button_index >= 0 &&
      data.default_button_index < me.buttons.length) {
      me.secondery_button_index = data.default_button_index;

    }
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-selectiondialog ngOnDestroy")
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("ChoiceDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

}
